export default "__VITE_ASSET__DrG$u2ux__"